'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MobileContextProvider = require('./MobileContextProvider');

Object.keys(_MobileContextProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MobileContextProvider[key];
    }
  });
});